module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Stranded_eBook-2.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "EB para-style-override-4",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Copyright © 2005 by Val McDermid")])]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace"
  }, [_vm._v("Ian Rankin foreword copyright © John Rebus Ltd. 2005")]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace"
  }, [_vm._v("First published in Great Britain in 2005 by Flambard Press.")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("Grove/Atlantic, Inc. wishes to thank Flambard Press for permission to use their files.")]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated. Any member of educational institutions wishing to photocopy part or all of the work for classroom use, or anthology, should send inquiries to Grove/Atlantic, Inc., 154 West 14th Street, New York, NY 10011 or "), _c('a', {
    attrs: {
      "href": "mailto:permissions@groveatlantic.com"
    }
  }, [_vm._v("permissions@groveatlantic.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace"
  }, [_vm._v("Copyright this collection © Val McDermid 2005")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘Mittel’ copyright © Val McDermid 2003, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("Europride Anthology ")]), _vm._v("(Comma Press, 2003)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘Driving a Hard Bargain’ copyright © Val McDermid 1996, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("The Mail on Sunday ")]), _vm._v("(1996)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘The Wagon Mound’ copyright © Val McDermid 2002, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("Good Housekeeping ")]), _vm._v("(2002)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘Breathtaking Ignorance’ copyright © Val McDermid 1996, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("The Crazy Jig ")]), _vm._v("(Polygon, 1996)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘White Nights, Black Magic’ copyright © Val McDermid 2002, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("Crime in the City ")]), _vm._v("(Do-Not Press, 2002)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘The Writing on the Wall’ copyright © Val McDermid 1994, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("3rd Culprit ")]), _vm._v("(Chatto & Windus, 1994)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘Keeping on the Right Side of the Law’ copyright © Val McDermid 1999, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("The City Life Book of Manchester Stories ")]), _vm._v("(Penguin, 1999)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘A Wife in a Million’ copyright © Val McDermid 1989, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("Reader, I Murdered Him ")]), _vm._v("(The Women’s Press, 1989)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘A Traditional Christmas’ copyright © Val McDermid 1994, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("Reader, I Murdered Him Too ")]), _vm._v("(The Women’s Press, 1994)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘The Girl Who Killed Santa Claus’ copyright © Val McDermid 2000, first published in the "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("News of the World ")]), _vm._v("magazine (2000)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘Sneeze for Danger’ copyright © Val McDermid 2004, commissioned and broadcast by BBC Radio 4 (2004)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘Guilt Trip’ copyright © Val McDermid 1995, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("No Alibi ")]), _vm._v("(Ringpull Press, 1995)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘Homecoming’ copyright © Val McDermid 2004, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("Endangered Species ")]), _vm._v("(Arts Council online anthology, 2004)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘Heartburn’ copyright © Val McDermid 1995, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("Northern Blood 2 ")]), _vm._v("(Flambard Press, 1995)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘Four Calling Birds’ copyright © Val McDermid 2004, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("12 Days ")]), _vm._v("(Virago, 2004)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘The Consolation Blonde’ copyright © Val McDermid 2003, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("Mysterious Pleasures ")]), _vm._v("(Little, Brown, 2003)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘Metamorphosis’ copyright © Val McDermid 2002, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("Tart Noir ")]), _vm._v("(Picador, 2002)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘When Larry Met Allie’ copyright © Val McDermid 2000, first published in "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("The New English Library Book of Internet Stories ")]), _vm._v("(New English Library, 2000)")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("‘The Road and the Miles to Dundee’ copyright © Val McDermid 2004, commissioned by New Writing North in 2004 and previously unpublished ")]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace"
  }, [_vm._v("eISBN: 978-0-8021-9174-8")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("Grove Press")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_c('span', {
    staticClass: "char-style-override-6"
  }, [_vm._v("an imprint of Grove/Atlantic, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("154 West 14th Street")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("New York, NY  10011")]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace para-style-override-5"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "CRSpace para-style-override-5"
  }, [_c('a', {
    attrs: {
      "href": "http://www.groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("groveatlantic.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42c7dd3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stranded_eBook2.vue
// module id = 66
// module chunks = 0